import { render, staticRenderFns } from "./cardTodoNoOrder.vue?vue&type=template&id=d845b582"
import script from "./cardTodoNoOrder.vue?vue&type=script&lang=js"
export * from "./cardTodoNoOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports